module.exports = __webpack_public_path__ + "img/logo_anan.6cf9d795.svg";